// src/api/agentService.js

import { getCookieValue } from '../api/cookie';

const API_URL = process.env.REACT_APP_API_URL || "";

/** Minimal helpers for GET/POST with JSON */
async function getJson(endpoint) {
    const csrfToken = getCookieValue('csrf_token'); 
    const res = await fetch(`${API_URL}${endpoint}`, {
      credentials: 'include',
      headers: { 'X-CSRFToken': csrfToken },
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Request failed');
    return data;
}   

async function postJson(endpoint, payload = {}) {
    const csrfToken = getCookieValue('csrf_token');
    const res = await fetch(`${API_URL}${endpoint}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken 
        },
        body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Request failed');
    return data;
}

async function patchJson(endpoint, payload = {}) {
    const csrfToken = getCookieValue('csrf_token');
    const res = await fetch(`${API_URL}${endpoint}`, {
        method: 'PATCH',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken 
        },
        body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Request failed');
    return data;
}

async function deleteJson(endpoint) {
    const csrfToken = getCookieValue('csrf_token');
    const res = await fetch(`${API_URL}${endpoint}`, {
        method: 'DELETE',
        credentials: 'include',
        headers: {
            'X-CSRFToken': csrfToken 
        },
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Request failed');
    return data;
}

// 1) Fetch paginated agents with optional search
export function fetchAgents(page, limit, searchTerm, noBlacklist, blacklistOnly) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      noBlacklist: noBlacklist.toString()
    });
    
    if (searchTerm) {
      params.set('searchTerm', searchTerm);
    }
    
    if (blacklistOnly) {
      params.set('blacklistOnly', blacklistOnly.toString());
    }
    
    return getJson(`/api/agents?${params.toString()}`);
  }

// 2) Add a new agent
export function addAgent(agentData) {
    return postJson('/api/agents', agentData);
}

// 3) Update an existing agent
export function updateAgent(agentId, agentData) {
    return patchJson(`/api/agents/${agentId}`, agentData);
}

// 4) Delete an agent
export function deleteAgent(agentId) {
    return deleteJson(`/api/agents/${agentId}`);
}

// 8) Update declaration industry
export function updateAgentEmail(agent_id, email) {
    return patchJson(`/api/agents/${agent_id}`, { email: email });
}

export function toggleAgentBlacklist(agentId) {
    return postJson(`/api/agents/toggle-blacklist/${agentId}`)
  };


export function fetchMergeConflicts() {
return getJson('/api/agents/merge-conflicts');
}

// Merge two agents
export function mergeAgents(primaryAgentId, secondaryAgentId, mergedData) {
    return postJson(`/api/agents/merge`, {
      primaryAgentId,    // ID of the agent to keep (will be updated with merged data)
      secondaryAgentId,  // ID of the agent to delete
      mergedData         // The merged data to apply to the primary agent
    });
  }

  export function markNoMergeNeeded(agent1Id, agent2Id) {
    return postJson('/api/agents/mark-no-merge', {
      agent1Id,
      agent2Id
    });
  }